import { makeEroadStyles } from "../../../styles";

type StyleProps = {
  hasBottomNav?: boolean;
  hasTopNav?: boolean;
};

const useStyles = makeEroadStyles(
  (theme) => ({
    header: ({ hasBottomNav, hasTopNav }: StyleProps) => ({
      backgroundColor: theme.colors.surfaceLevel1,
      padding: theme.spacing(6),
      paddingBottom: hasBottomNav ? 0 : theme.spacing(6),
      paddingTop: hasTopNav ? 0 : theme.spacing(6),

      "& > .ant-tabs": {
        marginBottom: hasTopNav ? theme.spacing(6) : 0,
      },

      [`@media (max-width: ${theme.breakpoints.values.lg}px)`]: {
        padding: theme.spacing(3),
        paddingBottom: hasBottomNav ? 0 : theme.spacing(3),
        paddingTop: hasTopNav ? 0 : theme.spacing(3),

        "& > .ant-tabs": {
          marginBottom: hasTopNav ? theme.spacing(3) : 0,
        },
      },

      [`@media (max-width: ${theme.breakpoints.values.sm}px)`]: {
        padding: theme.spacing(2),
        paddingBottom: hasBottomNav ? 0 : theme.spacing(2),
        paddingTop: hasTopNav ? 0 : theme.spacing(2),

        "& > .ant-tabs": {
          marginBottom: hasTopNav ? theme.spacing(2) : 0,
        },
      },
    }),

    backCompat: {
      [`@media (max-width: ${theme.breakpoints.values.md}px)`]: {
        display: "flex",
      },
    },
  }),
  { name: "PageHeader" }
);

export { useStyles };
